import React from 'react';
import { Crosshair, CheckCircle2 } from 'lucide-react';
export function ADAS() {
  return <section className="py-16 lg:py-24 bg-white" data-id="element-469" data-mp="cv8tx7q0pi6d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-470" data-mp="cwjxb6fjwnwy">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-471" data-mp="quqk9riyp3hu">
          <div className="scroll-fade-up" data-id="element-472" data-mp="mt55u1qs4h5j">
            <div className="w-12 h-12 bg-brand-light rounded-lg flex items-center justify-center mb-6" data-id="element-473" data-mp="mrbvabd1pcs9">
              <Crosshair className="w-6 h-6 text-brand-blue" data-id="element-474" data-mp="10r3c0juy579y" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-475" data-mp="vss5oj3v1ewh">
              Windshield Replacement with On-Site ADAS Calibration
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-476" data-mp="15jmu9u4kwql3">
              Many modern vehicles use cameras and sensors mounted near the
              windshield for driver-assistance features. After windshield
              replacement, those systems may need recalibration so features like
              lane departure warning, adaptive cruise control and automatic
              emergency braking work correctly.
            </p>
            <a href="#quote" className="inline-flex items-center text-brand-blue font-bold hover:text-brand-hover transition-colors group" data-id="element-477" data-mp="3tfa62zyxqs6m">
              Get a Free Quote with ADAS Calibration
              <span className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-478" data-mp="74xs8o3ip3e4">
                →
              </span>
            </a>
          </div>

          <div className="bg-slate-50 rounded-lg p-8 border border-slate-100 scroll-fade-scale" style={{
          animationDelay: '0.15s'
        }} data-id="element-479" data-mp="g6ntsmr45ipm">
            <h3 className="text-xl font-bold text-navy-900 mb-6" data-id="element-480" data-mp="pwqkggarikks">
              Why Calibration Matters
            </h3>
            <ul className="space-y-5" data-id="element-481" data-mp="uyfuptq5uu7t">
              {['Windshield replacement and ADAS recalibration handled in one place', 'Trained technicians and precise calibration equipment', 'Helps reduce downtime and extra appointments', 'Supports safety systems after replacement'].map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-482" data-mp="34sfwyr7by1o2" data-mpi={i}>
                  <div className="w-6 h-6 rounded-full bg-white shadow-sm flex items-center justify-center shrink-0 mt-0.5" data-id="element-483" data-mp="300xx66h1m74o">
                    <CheckCircle2 className="w-4 h-4 text-brand-blue" data-id="element-484" data-mp="3eoj1u4tkgeep" />
                  </div>
                  <span className="text-slate-700 font-medium" data-id="element-485" data-mp="39rak25cbycdz">{point}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}